// Keep speculative requests bounded and let the browser own the image cache.
const requests = new Map();

export function preloadPortfolioImage(src) {
  const connection = navigator.connection;
  if (!src || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType))
    return;
  if (requests.has(src)) return requests.get(src);

  const request = new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.fetchPriority = "low";
    image.src = src;
  });
  requests.set(src, request);
  if (requests.size > 32) requests.delete(requests.keys().next().value);
  request.then((loaded) => {
    if (!loaded && requests.get(src) === request) requests.delete(src);
  });
  return request;
}
